import React from "react";
import {
  FaBriefcase,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaBuilding,
} from "react-icons/fa";
import "./Experience.css";

const Experience = () => {
  const experiences = [
    {
      title: "Software Engineer",
      company: "AppSquadz Software Pvt. Ltd.",
      period: "07/2026 - Present",
      location: "Noida, Uttar Pradesh",
      responsibilities: [
        "Developed and maintained Appsquadz India and Dubai websites.",
        "Built a CMS for managing dynamic sections and website banners.",
        "Contributed to CloudBuddi, an AWS cloud cost management platform.",
      ],
    },
    {
      title: "Software Engineer L1",
      company: "Xorlabs Pvt.Ltd",
      period: "09/2024 - 06/2026",
      location: "Greater Noida, Uttar Pradesh",
      responsibilities: [
        "Implemented Twilio-based SMS automation workflows, reducing manual patient follow-ups by 60%.",
        "Designed a dynamic UI configuration system to reduce engineering dependency and enable admin-driven changes.",
        "Developed scalable healthcare web applications managing thousands of patient records.",
        "Deployed backend services on AWS EC2 and integrated AWS S3 for secure asset management.",
      ],
    },
    {
      title: "Associate Software Engineer",
      company: "Xorlabs Pvt.Ltd",
      period: "02/2024 - 08/2024",
      location: "Ghaziabad, Uttar Pradesh",
      responsibilities: [
        "Optimized MongoDB aggregation pipelines, reducing API response times by approximately 40%.",
        "Built analytical dashboards using Highcharts with CSV export functionality for healthcare professionals.",
        "Automated critical health alert notifications via email and SMS channels to improve operational efficiency.",
      ],
    },
    {
      title: "Junior Software Engineer",
      company: "Xorlabs Pvt.Ltd",
      period: "02/2023 - 01/2024",
      location: "Greater Noida, Uttar Pradesh",
      responsibilities: [
        "Developed RESTful APIs for real-time patient health monitoring systems.",
        "Implemented telehealth dashboard features for iOS using Swift to improve clinician workflows.",
        "Contributed to frontend features using React.js and modular UI components.",
        "Integrated backend services and implemented secure API endpoints.",
      ],
    },
    {
      title: "Frontend Intern",
      company: "S2CODE Technology",
      period: "09/2022 - 10/2022",
      location: "Noida, Uttar Pradesh",
      responsibilities: [
        "Developed functionalities using vanilla JavaScript.",
        "Designed reusable layouts with CSS to optimize UI consistency.",
      ],
    },
  ];

  return (
    <section id="experience" className="experience">
      <div className="container">
        <h2 className="section-title">Professional Experience</h2>

        <div className="timeline">
          {experiences.map((exp, index) => (
            <div key={index} className="timeline-item">
              <div className="timeline-marker">
                <div className="marker-dot"></div>
                <div className="marker-line"></div>
              </div>

              <div className="timeline-content">
                <div className="experience-header">
                  <div className="experience-title">
                    <FaBriefcase className="icon" />
                    <h3>{exp.title}</h3>
                  </div>
                  <div className="experience-company">
                    <FaBuilding className="icon" />
                    <span>{exp.company}</span>
                  </div>
                </div>

                <div className="experience-meta">
                  <div className="meta-item">
                    <FaCalendarAlt className="icon" />
                    <span>{exp.period}</span>
                  </div>
                  <div className="meta-item">
                    <FaMapMarkerAlt className="icon" />
                    <span>{exp.location}</span>
                  </div>
                </div>

                <ul className="responsibilities">
                  {exp.responsibilities.map((resp, respIndex) => (
                    <li key={respIndex}>{resp}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
